// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 781 ? "f3655696" : chunkId) + "." + {"63":"2cdb273a23b2d200","444":"6e490dc9d7e86a35","781":"11da09f92e7e99eb"}[chunkId] + ".js";
};